import { useNavigate } from "react-router-dom";

const ProvidersSection = ({casinoLobby}) => {
  const navigate = useNavigate();

  const handleProviderClick = (provider: any) => {
    if (provider?.gameId == null) {
      navigate({
        pathname: '/casino',
        search: `?subProvider=${encodeURIComponent(provider?.providerName)}&category=${provider?.sectionCategory ? encodeURIComponent(provider?.sectionCategory) : 'ALL'}`,
      });
    } else {
      navigate(
        `/dc/gamev1.1/${provider?.gameName?.toLowerCase().replace(/\s+/g, "-")}-${btoa(
          provider?.gameId?.toString()
        )}-${btoa(provider?.gameCode)}-${btoa(provider)}-${btoa(provider?.subProvider)}-${btoa(provider?.superProvider)}`,
        {state: {gameName: provider?.gameName}}
      );
    }
  };

  return (
    <section className="flex flex-col" aria-label="Casino Lobby">
      <div className="grid grid-cols-3 rounded-xl pb-0 md:grid-cols-4 md:p-3 min-[1201px]:grid-cols-5 min-[1201px]:p-1 min-[1201px]:pb-0">
        {casinoLobby.map((provider) => (
          <button
            key={provider.providerName}
            type="button"
            className="relative flex min-h-[60px] flex-col items-center justify-center gap-1 overflow-hidden border-2 border-selectedSidebarBg bg-mobile-footer-background-color p-2.5 px-1.5 cursor-pointer transition-all duration-200 ease-in-out hover:bg-selectedSidebarBg hover:shadow-[0_4px_12px_rgba(0,0,0,0.3)] sm:min-h-[70px] sm:gap-1.5 sm:px-2 sm:py-3 md:min-h-20 md:gap-2 md:p-0"
            onClick={() => handleProviderClick(provider)}
            aria-label={`${provider.providerName} casino provider`}
          >
            <div className="flex w-full shrink-0 items-center justify-center max-[920px]:h-[38px] max-[920px]:w-7 max-[480px]:h-auto max-[480px]:w-full">
              <img
                src={provider.sectionImage || provider.trendingThumbnail || provider.urlThumb}
                alt={provider.providerName}
                className="max-h-full max-w-full object-contain brightness-110"
                loading="lazy"
              />
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default ProvidersSection;